<div class="col-span-2 bg-transparent">

    <div *ngIf="reportSearch.search_person?.enhanced_data?.organization" class="flex justify-start w-full">

        <div class="w-full">

            <div class="flex items-start lg:items-center mb-3">

              <div class="hidden lg:block max-w-[5.25rem] max-h-[4.5rem] w-[5.25rem] h-[4.5rem] bg-violet-50/50 dark:bg-secondary-800 rounded-xl">
                  <img class="relative w-full h-full object-cover rounded-xl" [src]="company?.logo_url" (error)="onImageError($event, company)" alt="company logo">
              </div>

              <div class="grid grid-cols-5 gap-3 w-full ml-0 lg:ml-3">

                <div class="col-span-5 lg:col-span-3 flex items-center bg-violet-50/50 dark:bg-secondary-800 rounded-xl p-3 w-full">

                    <div class="w-full">
                      <div class="flex justify-between">
                        <app-change-company
                          [reportSearch]="reportSearch"
                          [company]="company"
                          [companies]="companies"
                        ></app-change-company>

                        <!-- Veridion Info -->
                        <button *ngIf="company?.veridion_data?.result && company.veridion_data.result.length > 0"
                                (click)="openCompanyDetails()"
                                class="bg-violet-50 p-1 rounded-lg hover:opacity-90">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-5 text-violet-500">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
                          </svg>
                        </button>

                        <button type="button" (click)="expandCompany(false)" class="block lg:hidden">
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="text-gray-500 size-6">
                            <path d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                          </svg>
                        </button>
                      </div>
                      <p class="text-sm text-[#3c4377] dark:text-primary-200">{{ company?.city ? company?.city + ',' : '' }} {{ company?.state ? company?.state + ',' : '' }} {{ company?.country }}</p>
                    </div>

                </div>

                <div class="col-span-5 lg:col-span-2">

                  <div class="flex items-stretch">

                    <div class="block lg:hidden shrink-0 max-w-[5.25rem] max-h-[4.5rem] w-[5.25rem] mr-3 h-[4.5rem] bg-violet-50/50 dark:bg-secondary-800 rounded-xl">
                      <img class="relative w-full h-full object-cover rounded-xl" [src]="company?.logo_url" (error)="onImageError($event, company)" alt="company logo">
                    </div>

                    <!-- Side by side when both fit, stacked when the column is too narrow -->
                    <div class="flex flex-wrap gap-3 w-full min-w-0">
                      <app-icp-score-header class="block flex-1 basis-56"
                                            [report]="report"
                                            [company]="company"
                                            (icpScoreClicked)="onIcpScoreClicked()">
                      </app-icp-score-header>

                      <!-- Sales Qualifying Agent (SQL score) -->
                      <app-sql-qualification class="block flex-1 basis-56" [report]="report" [company]="company"></app-sql-qualification>
                    </div>

                  </div>

                </div>


              </div>

            </div>

            <div class="bg-violet-50/50 dark:bg-secondary-800 rounded-xl p-3">

              <div class="grid grid-cols-2 gap-3 sm:grid-cols-4 relative top-1 mb-3">

                <!-- Revenue -->
                <div class="col-span-1 lg:col-span-1">

                  <div class="flex">
                    <dt class="text-sm font-medium leading-6 text-secondary mr-1 md:mr-2">
                      <svg viewBox="0 0 20 18" fill="none" class="w-4 fill-[#3B4377] dark:fill-white">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.25 3.375C0.25 2.85485 0.506174 2.42721 0.827295 2.11087C1.14577 1.79714 1.56814 1.54912 2.02956 1.35687C2.95566 0.970989 4.18309 0.75 5.5 0.75C6.81691 0.75 8.04434 0.970989 8.97044 1.35687C9.43186 1.54912 9.85423 1.79714 10.1727 2.11087C10.4938 2.42721 10.75 2.85485 10.75 3.375V7.48284C10.8412 7.43843 10.9345 7.39646 11.0296 7.35687C11.9557 6.97099 13.1831 6.75 14.5 6.75C15.8169 6.75 17.0443 6.97099 17.9704 7.35687C18.4319 7.54912 18.8542 7.79714 19.1727 8.11087C19.4938 8.42721 19.75 8.85485 19.75 9.375V15.2812C19.75 15.8012 19.506 16.2375 19.1856 16.5689C18.8687 16.8967 18.4463 17.1576 17.9826 17.3605C17.0529 17.7672 15.8211 18 14.5 18C13.1789 18 11.9471 17.7672 11.0174 17.3605C10.6392 17.195 10.2884 16.9909 10 16.7434C9.71157 16.9909 9.36084 17.195 8.98259 17.3605C8.05293 17.7672 6.82106 18 5.5 18C4.17894 18 2.94707 17.7672 2.01741 17.3605C1.55369 17.1576 1.13133 16.8967 0.81442 16.5689C0.494026 16.2375 0.25 15.8012 0.25 15.2812V3.375ZM1.75 3.375C1.75 3.37103 1.7502 3.35711 1.76462 3.32774C1.78037 3.29567 1.81363 3.24481 1.87997 3.17946C2.01692 3.04455 2.25356 2.88853 2.60648 2.74148C3.30905 2.44874 4.33163 2.25 5.5 2.25C6.66837 2.25 7.69095 2.44874 8.39352 2.74148C8.74644 2.88853 8.98308 3.04455 9.12003 3.17946C9.18637 3.24481 9.21963 3.29567 9.23538 3.32774C9.2498 3.35711 9.25 3.37103 9.25 3.375C9.25 3.37897 9.2498 3.39289 9.23538 3.42226C9.21963 3.45433 9.18637 3.50519 9.12003 3.57054C8.98308 3.70545 8.74644 3.86147 8.39352 4.00852C7.69095 4.30126 6.66837 4.5 5.5 4.5C4.33163 4.5 3.30905 4.30126 2.60648 4.00852C2.25356 3.86147 2.01692 3.70545 1.87997 3.57054C1.81363 3.50519 1.78037 3.45433 1.76462 3.42226C1.7502 3.39289 1.75 3.37897 1.75 3.375ZM1.75 12.2812C1.75 12.3049 1.75781 12.3866 1.89284 12.5263C2.03136 12.6696 2.26801 12.8329 2.61863 12.9862C3.31765 13.2921 4.33578 13.5 5.5 13.5C6.66422 13.5 7.68235 13.2921 8.38137 12.9862C8.73199 12.8329 8.96864 12.6696 9.10716 12.5263C9.24219 12.3866 9.25 12.3049 9.25 12.2812V11.2344C9.16278 11.2787 9.07348 11.3207 8.98259 11.3605C8.05293 11.7672 6.82106 12 5.5 12C4.17894 12 2.94707 11.7672 2.01741 11.3605C1.92652 11.3207 1.83722 11.2787 1.75 11.2344V12.2812ZM10.75 12.2812C10.75 12.3049 10.7578 12.3866 10.8928 12.5263C11.0314 12.6696 11.268 12.8329 11.6186 12.9862C12.3176 13.2921 13.3358 13.5 14.5 13.5C15.6642 13.5 16.6824 13.2921 17.3814 12.9862C17.732 12.8329 17.9686 12.6696 18.1072 12.5263C18.2422 12.3866 18.25 12.3049 18.25 12.2812V11.2672C18.1588 11.3116 18.0655 11.3535 17.9704 11.3931C17.0443 11.779 15.8169 12 14.5 12C13.1831 12 11.9557 11.779 11.0296 11.3931C10.9345 11.3535 10.8412 11.3116 10.75 11.2672V12.2812ZM10.75 14.2344V15.2812C10.75 15.3049 10.7578 15.3866 10.8928 15.5263C11.0314 15.6696 11.268 15.8329 11.6186 15.9862C12.3176 16.2921 13.3358 16.5 14.5 16.5C15.6642 16.5 16.6824 16.2921 17.3814 15.9862C17.732 15.8329 17.9686 15.6696 18.1072 15.5263C18.2422 15.3866 18.25 15.3049 18.25 15.2812V14.2344C18.1628 14.2787 18.0735 14.3207 17.9826 14.3605C17.0529 14.7672 15.8211 15 14.5 15C13.1789 15 11.9471 14.7672 11.0174 14.3605C10.9265 14.3207 10.8372 14.2787 10.75 14.2344ZM9.25 14.2344C9.16278 14.2787 9.07348 14.3207 8.98259 14.3605C8.05293 14.7672 6.82106 15 5.5 15C4.17894 15 2.94707 14.7672 2.01741 14.3605C1.92652 14.3207 1.83722 14.2787 1.75 14.2344V15.2812C1.75 15.3049 1.75781 15.3866 1.89284 15.5263C2.03136 15.6696 2.26801 15.8329 2.61863 15.9862C3.31765 16.2921 4.33578 16.5 5.5 16.5C6.66422 16.5 7.68235 16.2921 8.38137 15.9862C8.73199 15.8329 8.96864 15.6696 9.10716 15.5263C9.24219 15.3866 9.25 15.3049 9.25 15.2812V14.2344ZM10.7646 9.42226C10.7502 9.39289 10.75 9.37897 10.75 9.375C10.75 9.37103 10.7502 9.35711 10.7646 9.32774C10.7804 9.29567 10.8136 9.24481 10.88 9.17946C11.0169 9.04455 11.2536 8.88853 11.6065 8.74148C12.3091 8.44874 13.3316 8.25 14.5 8.25C15.6684 8.25 16.6909 8.44874 17.3935 8.74148C17.7464 8.88853 17.9831 9.04455 18.12 9.17946C18.1864 9.24481 18.2196 9.29567 18.2354 9.32774C18.2498 9.35711 18.25 9.37103 18.25 9.375C18.25 9.37897 18.2498 9.39289 18.2354 9.42226C18.2196 9.45433 18.1864 9.50519 18.12 9.57054C17.9831 9.70545 17.7464 9.86147 17.3935 10.0085C16.6909 10.3013 15.6684 10.5 14.5 10.5C13.3316 10.5 12.3091 10.3013 11.6065 10.0085C11.2536 9.86147 11.0169 9.70545 10.88 9.57054C10.8136 9.50519 10.7804 9.45433 10.7646 9.42226ZM9.25 9.28125C9.25 9.30493 9.24219 9.38661 9.10716 9.52628C8.96864 9.66956 8.73199 9.83285 8.38137 9.98625C7.68235 10.2921 6.66422 10.5 5.5 10.5C4.33578 10.5 3.31765 10.2921 2.61863 9.98625C2.26801 9.83285 2.03136 9.66956 1.89284 9.52628C1.75781 9.38661 1.75 9.30493 1.75 9.28125V8.23444C1.83722 8.27873 1.92652 8.32072 2.01741 8.36048C2.94707 8.76721 4.17894 9 5.5 9C6.82106 9 8.05293 8.76721 8.98259 8.36048C9.07348 8.32072 9.16278 8.27873 9.25 8.23444V9.28125ZM1.75 6.28125C1.75 6.30493 1.75781 6.38661 1.89284 6.52628C2.03136 6.66956 2.26801 6.83285 2.61863 6.98625C3.31765 7.29207 4.33578 7.5 5.5 7.5C6.66422 7.5 7.68235 7.29207 8.38137 6.98625C8.73199 6.83285 8.96864 6.66956 9.10716 6.52628C9.24219 6.38661 9.25 6.30493 9.25 6.28125V5.26716C9.15885 5.31158 9.06547 5.35354 8.97044 5.39313C8.04434 5.77901 6.81691 6 5.5 6C4.18309 6 2.95566 5.77901 2.02956 5.39313C1.93453 5.35354 1.84115 5.31158 1.75 5.26716V6.28125Z" />
                      </svg>
                    </dt>
                    <dd class="text-sm leading-6">
                      <div class="flex items-center space-x-3">
                        <p class="text-sm text-secondary dark:text-white flex items-center">Revenue</p>
                        <!--
                        <app-custom-tooltip [title]="'Title'" [description]="'Description'"></app-custom-tooltip>
                        -->
                      </div>
                      <div class="flex items-center space-x-3">
                        <!--
                        <p [ngClass]="{'cursor-pointer': isEstimatedRevenueVisible, 'text-gray-500': isCompanyRevenueLoading, 'text-secondary/75': !isCompanyRevenueLoading}" class="text-md md:text-md  dark:text-white font-semibold">
                          {{ companyRevenue }}
                        </p>
                        <app-pulse-loading *ngIf="isCompanyRevenueLoading" [status]="'loading'" [size]="'size-2'"></app-pulse-loading>
                        -->

                        <div *ngIf="company" class="flex items-center space-x-2">
                          <app-assistant-prompt #revenuePrompt
                                                tag="ASK_ASSISTANT_COMPANY_REVENUE"
                                                [title]="'Revenue Details'"
                                                [type]="'company-data'"
                                                [company]="company"
                                                [reportId]="report?.id">
                          </app-assistant-prompt>

                          <button *ngIf="revenuePrompt.shortContent !== null" (click)="openEditRevenueModalWithData()" class="text-secondary hover:opacity-90">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-4">
                              <path d="m2.695 14.762-1.262 3.155a.5.5 0 0 0 .65.65l3.155-1.262a4 4 0 0 0 1.343-.886L17.5 5.501a2.121 2.121 0 0 0-3-3L3.58 13.419a4 4 0 0 0-.885 1.343Z" />
                            </svg>
                          </button>

                        </div>

                      </div>
                    </dd>
                  </div>

                </div>
                <!-- / Revenue -->

                <!-- Profit (Commented out - replaced with Locations)
                <div class="col-span-1 lg:col-span-1">

                  <div class="flex">

                    <dt class="text-sm font-medium leading-6 text-secondary mr-1 md:mr-2">
                      <svg viewBox="0 0 18 18" fill="none" class="w-4 fill-[#3B4377] dark:fill-white">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M16.4763 0.120721C16.7375 0.262227 16.9223 0.512561 16.9806 0.803885L17.9806 5.80388C18.0889 6.34544 17.7377 6.87227 17.1961 6.98058C16.6546 7.08889 16.1277 6.73768 16.0194 6.19612L15.5486 3.84217L12.3716 9.49026C12.1945 9.80514 11.8613 10 11.5 10H4.693L1.93633 17.3511C1.74241 17.8682 1.16599 18.1302 0.648873 17.9363C0.131753 17.7424 -0.130253 17.166 0.0636672 16.6489L3.06367 8.64888C3.21003 8.25857 3.58315 8 4 8H10.9151L13.7378 2.9819L11.3714 3.92848C10.8586 4.13359 10.2766 3.88418 10.0715 3.37139C9.86641 2.85861 10.1158 2.27664 10.6286 2.07152L15.6286 0.0715242C15.9044 -0.0388134 16.2151 -0.0207862 16.4763 0.120721Z" />
                      </svg>
                    </dt>

                    <dd class="text-sm leading-6">
                      <p class="text-sm text-secondary dark:text-white">Profit</p>
                      <div class="flex items-center space-x-3">
                        <p [ngClass]="{'text-gray-500': isCompanyProfitLoading, 'text-secondary/75': !isCompanyProfitLoading}"
                           class="text-md md:text-md  dark:text-white font-semibold"
                        >
                          {{ companyProfit }}
                        </p>
                        <app-pulse-loading *ngIf="isCompanyProfitLoading" [status]="'loading'" [size]="'size-2'"></app-pulse-loading>
                      </div>
                    </dd>
                  </div>

                </div>
                -->

                <!-- Locations -->
                <div class="col-span-1 lg:col-span-1">

                  <div class="flex">

                    <dt class="text-sm font-medium leading-6 text-secondary mr-1 md:mr-2">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4 text-[#3B4377] dark:text-white stroke-2">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                        <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z" />
                      </svg>
                    </dt>

                    <dd class="text-sm leading-6">
                      <p class="text-sm text-secondary dark:text-white">Locations</p>
                      <div class="flex items-center space-x-3">
                        <p class="text-md md:text-md text-secondary/75 dark:text-white font-semibold">
                          {{ company?.veridion_data?.result?.num_locations || 'N/A' }}
                        </p>
                      </div>
                    </dd>
                  </div>

                </div>
                <!-- / Locations -->

                <!-- Funding -->
                <div class="col-span-1 lg:col-span-1">

                  <div class="flex">

                    <dt class="text-sm font-medium leading-6 mr-1 md:mr-2">
                      <svg class="w-6 h-6 text-secondary dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                        <path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M8 7V6a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-1M3 18v-7a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1Zm8-3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"/>
                      </svg>
                    </dt>

                    <dd class="text-sm leading-6 ">
                      <p class="text-sm text-secondary dark:text-white">Funding</p>
                      <div class="flex items-center space-x-3">
                        <p [ngClass]="{'cursor-pointer': isEstimatedFundingVisible, 'text-gray-500': isCompanyFundingLoading, 'text-gray-700': !isCompanyFundingLoading}" class="text-md md:text-md text-secondary/75 dark:text-white font-semibold">
                          {{ company?.funding || 'N/A' }}
                        </p>
                        <app-pulse-loading *ngIf="isCompanyFundingLoading" [status]="'loading'" [size]="'size-2'"></app-pulse-loading>
                      </div>

                    </dd>
                  </div>

                </div>
                <!-- / Funding -->

                <!-- Employees -->
                <div class="col-span-1 lg:col-span-1">

                  <div class="flex">
                    <dt class="text-sm font-medium leading-6 mr-1 md:mr-2">
                      <svg viewBox="0 0 21 17" fill="none" class="w-4 fill-[#3B4377] dark:fill-white relative top-[2px]">
                        <path d="M10.5 6C12.1569 6 13.5 4.65685 13.5 3C13.5 1.34315 12.1569 0 10.5 0C8.84315 0 7.5 1.34315 7.5 3C7.5 4.65685 8.84315 6 10.5 6Z" />
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M5.57489 8.82411C5.05438 9.58614 4.75 10.5075 4.75 11.5V14.5C4.75 15.4665 5.5335 16.25 6.5 16.25H14.5C15.4665 16.25 16.25 15.4665 16.25 14.5V11.5C16.25 10.5075 15.9456 9.58614 15.4251 8.82411C15.6086 8.77576 15.8013 8.75 16 8.75H17C18.2426 8.75 19.25 9.75736 19.25 11V14C19.25 14.4142 19.5858 14.75 20 14.75C20.4142 14.75 20.75 14.4142 20.75 14V11C20.75 8.92893 19.0711 7.25 17 7.25H16C15.3861 7.25 14.8066 7.39752 14.2951 7.65905C13.5109 7.08734 12.5448 6.75 11.5 6.75H9.5C8.45517 6.75 7.48913 7.08734 6.70486 7.65906C6.19337 7.39752 5.61392 7.25 5 7.25H4C1.92893 7.25 0.25 8.92893 0.25 11V14C0.25 14.4142 0.585786 14.75 1 14.75C1.41421 14.75 1.75 14.4142 1.75 14V11C1.75 9.75736 2.75736 8.75 4 8.75H5C5.1987 8.75 5.39138 8.77576 5.57489 8.82411ZM6.25 11.5C6.25 9.70507 7.70507 8.25 9.5 8.25H11.5C13.2949 8.25 14.75 9.70507 14.75 11.5V14.5C14.75 14.6381 14.6381 14.75 14.5 14.75H6.5C6.36193 14.75 6.25 14.6381 6.25 14.5V11.5Z" />
                        <path d="M7 4C7 5.38071 5.88071 6.5 4.5 6.5C3.11929 6.5 2 5.38071 2 4C2 2.61929 3.11929 1.5 4.5 1.5C5.88071 1.5 7 2.61929 7 4Z"/>
                        <path d="M16.5 6.5C17.8807 6.5 19 5.38071 19 4C19 2.61929 17.8807 1.5 16.5 1.5C15.1193 1.5 14 2.61929 14 4C14 5.38071 15.1193 6.5 16.5 6.5Z" />
                      </svg>
                    </dt>
                    <dd class="text-sm leading-6">
                      <p class="text-sm text-secondary dark:text-white">Employees</p>
                      <div class="flex items-center space-x-3">
                        <p [ngClass]="{'text-gray-500': isCompanyEmployeesLoading, 'text-secondary': !isCompanyEmployeesLoading}" class="text-md md:text-md text-secondary  dark:text-white font-semibold">
                          {{ company?.estimated_num_employees ? formatNumber(company?.estimated_num_employees) : 'N/A' }}
                        </p>
                        <app-pulse-loading *ngIf="isCompanyEmployeesLoading" [status]="'loading'" [size]="'size-2'"></app-pulse-loading>
                      </div>
                    </dd>
                  </div>

                </div>
                <!-- / Employees -->

              </div>

              <!-- Description -->
              <div *ngIf="company" class="mb-0 relative h-[4rem] max-h-[4rem]">

                <app-assistant-prompt tag="ASK_ASSISTANT_ABOUT_COMPANY"
                                      title="About company"
                                      [type]="'insights'"
                                      [company]="company"
                                      [reportId]="report?.id"
                                      [showButton]="true"
                                      [buttonType]="1"
                                      [class]="'line-clamp-2'">
                </app-assistant-prompt>

              </div>
              <!-- / Description -->

            </div>

        </div>

    </div>

    <div *ngIf="!reportSearch.search_person.enhanced_data?.organization" class="flex justify-center items-center p-6 h-[12rem]">
      <p class="text-sm text-gray-500">Company information was not found.</p>
    </div>

</div>
